<script>
  let { visibility } = $props()

  const TONE_CLASSES = {
    public: 'badge badge-success',
    friends_only: 'badge badge-info',
    private: 'badge badge-neutral'
  }

  const LABELS = {
    public: 'Public',
    friends_only: 'Friends Only',
    private: 'Private'
  }
</script>

<span class={TONE_CLASSES[visibility] || 'badge badge-ghost'}>{LABELS[visibility] || visibility}</span>
